var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-header" }, [
          _vm._v(_vm._s(_vm.$t("message.menu.company_address")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _c(
            "button",
            {
              staticClass: "button -cyan",
              on: {
                click: function($event) {
                  return _vm.openUserAddressFormModal(null, null)
                }
              }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(
                    _vm.$t("message.company_address.add_new_company_address")
                  ) +
                  "\n      "
              )
            ]
          ),
          _vm._v(" "),
          _vm.companies.length > 0
            ? _c("div", { staticClass: "table-responsive mt-4" }, [
                _c("table", { staticClass: "table" }, [
                  _c("thead", [
                    _c("tr", { staticClass: "d-flex" }, [
                      _c("th", { staticClass: "col-4" }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "message.company_address.company_customer_name"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("th", { staticClass: "col-6" }, [
                        _vm._v(
                          _vm._s(_vm.$t("message.company_address.address"))
                        )
                      ]),
                      _vm._v(" "),
                      _c("th", { staticClass: "col-2" }, [
                        _vm._v(_vm._s(_vm.$t("message.company_address.action")))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.companies, function(company, index) {
                      return _c("tr", { key: index, staticClass: "d-flex" }, [
                        _c("td", { staticClass: "col-4" }, [
                          _c("div", [_vm._v(_vm._s(company.company))]),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-2" }, [
                            _vm._v(
                              "\n                Tax ID: " +
                                _vm._s(company.tax_id) +
                                "\n              "
                            )
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-2" }, [
                            _c(
                              "span",
                              {
                                staticClass: "badge badge-pill badge-light",
                                staticStyle: { "background-color": "#E0E0E0" }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      company.is_company
                                        ? _vm.$t(
                                            "message.company_address.juristic_person"
                                          )
                                        : _vm.$t(
                                            "message.company_address.normal_person"
                                          )
                                    ) +
                                    "\n                "
                                )
                              ]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "col-6" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.getFullAddress(company)) +
                              "\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "col-2" }, [
                          _c("p", [
                            _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.openUserAddressFormModal(
                                      index,
                                      company.id
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("message.button.edit")) +
                                    "\n                "
                                )
                              ]
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.deleteUserCompany(
                                      index,
                                      company.id
                                    )
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(_vm.$t("message.button.delete")) +
                                    "\n                "
                                )
                              ]
                            )
                          ])
                        ])
                      ])
                    }),
                    0
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "text-center" }, [
            _vm.state.isMore
              ? _c(
                  "button",
                  {
                    staticClass: "button -cyan",
                    attrs: { disabled: _vm.state.isFetching },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.fetchCompanyAddresses.apply(null, arguments)
                      }
                    }
                  },
                  [_vm._v(" " + _vm._s(_vm.$t(_vm.isLoadMore)) + "\n        ")]
                )
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c("company-address-modal", {
        ref: "userCompanyModal",
        attrs: { manageData: false, formAction: _vm.formAction },
        on: { finished: _vm.fetchFirstPage }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f1aa9384", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1aa9384","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/companyAddress/Index.vue
// module id = 1928
// module chunks = 0